export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00977.8c44956b.png";